<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h5 v-if="!multiple" class="text-muted">{{$t('phone.phone')}}</h5>
        <h5 v-if="multiple" class="text-muted">{{$t('phone.phones')}}</h5>
      </div>
    </div>
    <div v-for="(item, index) in values">
      <div class="row">
        <div class="col-md-12">
          <p class="text-primary border-bottom" v-if="multiple">
            <b>Phone {{ index + 1 }}</b>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6"  v-if="multiple">
          <label for="type">{{$t('phone.type')}}</label>
          <input
            type="text"
            class="form-control"
            id="type"
            v-model="item.type"
            @input="updateValue"
          >
          <small class="text-muted">{{$t('phone.typetext')}}</small>
        </div>
        <div class="col-md-6">
          <label for="phone">{{$t('phone.phonenumber')}}</label>
          <input class="form-control" id="phone" v-model="item.phone" @input="updateValue"></input>
        </div>
      </div>
    </div>
    <div class="row" v-if="multiple">
      <div class="col-md-12">
        <a
          href="#"
          v-if="values.length > 1"
          class="btn btn-sm mr-3"
          @click="deleteValue()"
        >Delete Last Phone Number</a>
        <a href="#" class="btn btn-sm" @click="addValue()">{{$t('phone.addphone')}}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "fg-phone",
  props: {
    value: "",
    multiple: false
  },
  data() {
    return {
      values: [
        {
          type: "",
          phone: ""
        }
      ]
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newData) {
        this.values = Array.isArray(newData) && newData.length
          ? newData.map(item => Object.assign({}, item))
          : [{ type: "", phone: "" }];
      }
    }
  },
  methods: {
    updateValue() {
      this.$emit("input", this.values);
    },
    deleteValue() {
      let i = this.values.length - 1;
      if (i > 0) {
        this.values.splice(i, 1);
        this.$emit("input", this.values);
      }
    },
    addValue() {
      this.values.push({});
      this.$emit("input", this.values);
    }
  }
};
</script>
<style>
</style>
